const HOLD_ONE_TIME_ACTION = 'HOLD_ONE_TIME_ACTION';
const RESOLVE_ONE_TIME_ACTION = 'RESOLVE_ONE_TIME_ACTION';
const NOOP_ONE_TIME_ACTION = 'NOOP_ONE_TIME_ACTION';

// Ensures that identical actions are only called once until the first one is completed.
// Example: fooRequest makes an ajax request and then dispatches a FOO_RESPONSE action.
//          Dispatching two idential fooRequests in a row will issue two identical ajax requets, but calling
// oneTimeAction(fooRequest()) twice will make one ajax call and the second will noop. After the initial promise is
// resolved, subsequent calls will issue more requests.

export default (actionKey, actionPromise) => (dispatch, getState) => {
  const state = getState();

  if (state.oneTimeActions[actionKey]) {
    const { promise } = state.oneTimeActions[actionKey];

    dispatch({
      type: NOOP_ONE_TIME_ACTION
    });

    return promise;
  }

  const promise = dispatch(actionPromise);

  dispatch({
    type: HOLD_ONE_TIME_ACTION,
    promise,
    actionKey
  });

  return promise.then((resp) => {
    dispatch({
      type: RESOLVE_ONE_TIME_ACTION,
      actionKey
    });

    return Promise.resolve(resp);
  });
};
